var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gap',{attrs:{"top":"single","bottom":"single","right":"double"}},[_c('title-regular',[_vm._v("Description:")]),_c('text-regular',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }